<div class="flex flex-col gap-8 items-center px-4">
  <!-- Header skeleton -->
  <div class="flex flex-col gap-3 items-center text-center w-full max-w-2xl">
    <div class="h-7 w-48 md:w-64 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
    <div class="flex flex-col gap-1.5 items-center w-full">
      <div class="h-4 w-full max-w-sm rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
      <div class="h-4 w-3/4 max-w-xs rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
    </div>
  </div>

  <div class="flex flex-col gap-8 items-center w-full max-w-5xl 2xl:max-w-7xl">
    <!-- Payment filter skeleton (toggle pill) -->
    <div class="h-12 w-72 rounded-full overflow-hidden"><dss-libs-ui-skeleton /></div>

    <!-- Pricing cards skeleton -->
    <div class="flex flex-col sm:flex-row flex-wrap gap-6 items-stretch justify-center w-full">
      <!-- Card 1 -->
      <div
        class="bg-white border border-stroke-soft flex flex-col gap-8 items-center w-full sm:w-80 lg:w-96 p-6 rounded-lg"
      >
        <div class="flex flex-col gap-4 items-center text-center w-full">
          <div class="h-7 w-32 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="flex flex-col gap-1.5 items-center w-full">
            <div class="h-4 w-full rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 w-3/4 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
        </div>
        <div class="flex flex-col gap-2 items-center w-full">
          <div class="h-12 w-28 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="h-5 w-40 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
        </div>
        <div class="flex flex-col gap-3 w-full">
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
        </div>
        <div class="h-11 w-full rounded-md overflow-hidden mt-auto"><dss-libs-ui-skeleton /></div>
      </div>

      <!-- Card 2 -->
      <div
        class="bg-white border border-stroke-soft flex flex-col gap-8 items-center w-full sm:w-80 lg:w-96 p-6 rounded-lg"
      >
        <div class="flex flex-col gap-4 items-center text-center w-full">
          <div class="h-7 w-24 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="flex flex-col gap-1.5 items-center w-full">
            <div class="h-4 w-full rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 w-2/3 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
        </div>
        <div class="flex flex-col gap-2 items-center w-full">
          <div class="h-12 w-28 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="h-5 w-40 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
        </div>
        <div class="flex flex-col gap-3 w-full">
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
        </div>
        <div class="h-11 w-full rounded-md overflow-hidden mt-auto"><dss-libs-ui-skeleton /></div>
      </div>

      <!-- Card 3 -->
      <div
        class="bg-white border border-stroke-soft flex flex-col gap-8 items-center w-full sm:w-80 lg:w-96 p-6 rounded-lg"
      >
        <div class="flex flex-col gap-4 items-center text-center w-full">
          <div class="h-7 w-36 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="flex flex-col gap-1.5 items-center w-full">
            <div class="h-4 w-full rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 w-4/5 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
        </div>
        <div class="flex flex-col gap-2 items-center w-full">
          <div class="h-12 w-28 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="h-5 w-40 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
        </div>
        <div class="flex flex-col gap-3 w-full">
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
          <div class="flex gap-2.5 items-start w-full">
            <div class="size-5 rounded shrink-0 overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-4 flex-1 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
        </div>
        <div class="h-11 w-full rounded-md overflow-hidden mt-auto"><dss-libs-ui-skeleton /></div>
      </div>
    </div>

    <!-- Back button skeleton -->
    <div class="w-full flex justify-center">
      <div class="w-full sm:w-80 lg:w-[calc(3*24rem+2*1.5rem)] flex justify-start">
        <div class="h-10 w-36 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
      </div>
    </div>
  </div>
</div>
